import React, {useEffect, useState} from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    Drawer,
    List,
    ListItemIcon,
    ListItemText,
    Box,
    CssBaseline,
    ListItemButton,
    Tooltip,
    Button,
    Avatar, IconButton
} from '@mui/material';
import {
    Menu as MenuIcon,
    Home as HomeIcon,
    Apps as AppIcon,
    FirstPage
} from '@mui/icons-material';
import {Outlet, useNavigate} from "react-router-dom";
import {UserButton} from '@clerk/clerk-react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBook} from '@fortawesome/free-solid-svg-icons';
import AddIcon from "@mui/icons-material/Add";

export default function HomeLayout() {
    const [expanded, setExpanded] = useState(() => {
        // Initialize state from localStorage, default to false if not set
        const savedState = localStorage.getItem('sidebarExpanded');
        return savedState !== null ? JSON.parse(savedState) : false;
    });
    const navigate = useNavigate()


    // Update localStorage whenever expanded state changes
    useEffect(() => {
        localStorage.setItem('sidebarExpanded', JSON.stringify(expanded));
    }, [expanded]);

    const handleNavigation = (event: React.MouseEvent<HTMLAnchorElement>, path: string) => {
        event.preventDefault();
        navigate(path);
    };

    const handleDrawerToggle = () => {
        setExpanded(!expanded);
    };

    const sideNavItems = [
        {
            text: 'Dashboard', icon: <HomeIcon/>, onClick: (e: any) => {
                handleNavigation(e, '/h/dashboard')
            }, link: '/h/dashboard'
        },
        {
            text: 'Collections', icon: <AppIcon/>, onClick: (e: any) => {
                handleNavigation(e, '/h/collections')
            }, link: '/h/collections'
        },
    ];

    const drawerWidth = 240;
    const collapsedWidth = 0;

    return (
        <Box sx={{display: 'flex'}}>
            <CssBaseline/>

            {/* Top App Bar - Remains Static */}
            <AppBar position="fixed" sx={{zIndex: (theme) => theme.zIndex.drawer + 1}}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="toggle drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{mr: 2}}
                    >
                        {expanded ? <FirstPage/> : <MenuIcon/>}
                    </IconButton>

                    <Box display="flex" alignItems="center" sx={{flexGrow: 1}}>
                        <Button
                            color="inherit"
                            href="/h/dashboard"
                            onClick={(e) => handleNavigation(e as React.MouseEvent<HTMLAnchorElement>, '/h/dashboard')}
                            startIcon={
                                <Avatar
                                    src={`/web-app-manifest-512x512.png`}
                                    alt="TrackMyTrove"
                                />
                            }
                            sx={{textTransform: 'none'}}
                        >
                            <Typography variant="h6" component="div">
                                TrackMyTrove
                            </Typography>
                        </Button>
                    </Box>

                        <UserButton showName={true}>

                            <UserButton.MenuItems>
                                <UserButton.Action
                                    label="Open chat"
                                    labelIcon={<AddIcon/>}
                                    onClick={() => alert('init chat')}
                                />
                                <UserButton.Link href={"https://docs.trackmytrove.ai"} label={"Docs"}
                                                 labelIcon={<FontAwesomeIcon icon={faBook}/>}/>
                            </UserButton.MenuItems>
                        </UserButton>
                </Toolbar>
            </AppBar>

            {/* Side Navigation Drawer - Always Visible */}
            <Drawer
                variant="permanent"
                sx={{
                    width: expanded ? drawerWidth : collapsedWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: expanded ? drawerWidth : collapsedWidth,
                        boxSizing: 'border-box',
                        top: '64px', // Adjust based on AppBar height
                        height: 'calc(100% - 64px)',
                        overflowX: 'hidden',
                        transition: 'width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms'
                    },
                }}
                open={expanded}
            >
                <List>
                    {sideNavItems.map((item) => (
                        <Tooltip
                            key={item.text}
                            title={!expanded ? item.text : ''}
                            placement="right"
                        >
                            <ListItemButton
                                sx={{
                                    justifyContent: expanded ? 'initial' : 'center',
                                    px: 2.5,
                                }}
                                onClick={item.onClick}
                                href={item.link}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: expanded ? 3 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {item.icon}
                                </ListItemIcon>
                                {expanded && <ListItemText primary={item.text}/>}
                            </ListItemButton>
                        </Tooltip>
                    ))}
                </List>
            </Drawer>

            {/* Main Content Area */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: { xs: 1, sm: 2, md: 3 },
                    width: `calc(100% - ${expanded ? drawerWidth : collapsedWidth}px)`,
                    marginTop: '64px', // Match AppBar height
                    transition: 'width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms'
                }}
            >
                {/* Your main content goes here */}
                <Outlet/>
            </Box>
        </Box>
    );
}